import React from "react";
import "./MediaPage.scss";
import Video from "../../components/Video/Video";
import { TitleComponent } from "../../components/TitleDocument";
import BreadCrumb from "../../components/BreadCrumb";
import newsBackground from "../../assets/news_bg.svg";

const MEDIA_VIDEO_COPY = {
  title: "Thư viện video",
  description:
    "Khám phá thư viện video với các nội dung tiêu biểu về hoạt động, công nghệ và hạ tầng mạng lưới của VNPT Net, thể hiện năng lực triển khai và vận hành trên toàn hệ thống.",
};

const MediaPage = () => {
  return (
    <section className="video_media_page video_media_page--library">
      <TitleComponent title="Thu-vien-video" />

      <div className="video_media_page__shell">
        <div className="video_media_page__crumb container">
          <BreadCrumb caseCondition="case1" />
        </div>

        <div className="video_media_page__layout container">
          <main className="video_media_page__main">
            <div className="video_media_page__stage">
              <div
                className="video_media_page__bg"
                style={{ backgroundImage: `url(${newsBackground})` }}
                aria-hidden="true"
              />

              <section className="video_media_page__intro">
                <div className="video_media_page__intro-inner">
                  <h1>{MEDIA_VIDEO_COPY.title}</h1>
                  <p>{MEDIA_VIDEO_COPY.description}</p>
                </div>
              </section>

              <Video />
            </div>
          </main>
        </div>
      </div>
    </section>
  );
};

export default MediaPage;
